export default [
  {
    path: '/home',
    name: 'home',
    component: () => import('./Home.vue'),
    meta: {
      name: 'Página Inicial',
      auth: true,
      user: 'Admin',
    },
  },
]
